import { Add } from "iconsax-react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import { Button } from "../../Kit/Button";
import { Div, Icon, Text } from "../../Kit";
import { Modal } from "../../SharedComponents";
import settings from "../../../settings/settings";
import { useTheme } from "../../../Store/modules/theme";
import { ModalNames } from "../../../Constants/modalNames";
import { useLanguage } from "../../../Store/modules/language";
import { useModal } from "../../../Store/modules/modal/modal";
import { useWalletCashIn } from "../../../Store/modules/ai/walletCashIn/walletCashIn";
import { useTranslation } from "react-i18next";
import { makeMoneyFormat } from "../../../Utils/stringProcessor";

export const WalletCashInModal: React.FC = () => {
  const { direction } = useLanguage();
  const { register, handleSubmit, watch, reset } = useForm<{ amount: string }>();
  const { dispatchCloseModal } = useModal();
  const { name: theme } = useTheme();

  let { dispatchWalletCashIn, walletCashInLoading ,walletCashInData} = useWalletCashIn();
  let redirectLink = walletCashInData?.data?.redirect_link

  const onConfirm = ({ amount }: { amount: string }) => {
    const rawAmount = Number(amount.replace(/,/g, ""));
    if (isNaN(rawAmount) || rawAmount <= 0) return;

    dispatchWalletCashIn({ amount: rawAmount });
  };
  
  const { t } = useTranslation();

  useEffect(() => {
    reset();
  }, []);

  return (
    <Modal
      modalName={ModalNames.WalletCashInModal}
      modalClassName="rounded-[10px] relative w-[327px] flex flex-col justify-between items-center"
    >
      <Div
        bg="forthOpt"
        className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px]"
        onClick={() => dispatchCloseModal()}
      >
        <Icon Component={Add} size={20} className="rotate-[45deg]" color="text" />
      </Div>
      <div dir={direction} className="flex justify-center pt-[10px]">
        <img src={settings.logo?.[theme]} alt="logo" className="w-[60px]" />
      </div>
      <Text elementType="h6" className="text-center mt-8">
        walletCashIn.enterYourDesiredAmount
      </Text>
      <input
        type="text"
        className={`${theme === "dark" ? "text-white" : "text-dark"} border-0 rounded-[4px] outline-0 focus:outline-none h-[39px] text-sm px-2 mt-4 mb-1 w-full ${theme === "light" ? "bg-[#F5F5F7]" : "bg-[#1F1F1F]"}`}
        dir={watch()?.amount ? "ltr" : direction}
        //@ts-ignore
        placeholder={t("walletCashIn.enterAmount")}
        {...register("amount", {
          onChange: (e) => {
            e.target.value = makeMoneyFormat(e.target.value);
          },
        })}
        disabled={walletCashInLoading}
      />
      <div className="flex flex-col items-center justify-center">
        <Button
          title={redirectLink ? "walletCashIn.redirecting":"confirmationModal.payment"}
          className="w-full h-[45px] mt-[14px]"
          disabled={!!redirectLink}
          textClassName="text-sm"
          loading={walletCashInLoading}
          bg="primary"
          onClick={handleSubmit(onConfirm)}
        />
      </div>
    </Modal>
  );
};
